import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { IMAGE_URL } from "@/constants";
import { StaticImageData } from "next/image";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getImageURL(path: string, fallback?: string | StaticImageData) {
  if (!path) {
    return fallback ?? null;
  }

  if (path.startsWith("http")) {
    return path;
  }

  const baseURL = IMAGE_URL + path;

  return baseURL;
}

export function convertKeysToCamelCase<T extends Record<string, any>>(
  obj: T,
): { [K in Lowercase<keyof T & string>]: T[K] } {
  // Check if the input is indeed an object
  if (typeof obj !== "object" || obj === null) {
    throw new Error("Input must be an object");
  }

  const result: Partial<T> = {};

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      // Convert only the first character of the key to lowercase
      const lowerCaseKey = (key.charAt(0).toLowerCase() +
        key.slice(1)) as keyof T;
      result[lowerCaseKey] = obj[key];
    }
  }

  return result as T;
}
